export const ACCOUNT_LOGIN = '/account/login';
export const ACCOUNT_ACTIVATE = '/account/activate';
export const CART_LINK = '/cart';
